export const setValue = (option, value) => {
    if (option) {
        if (value.length > 3) {
            return value.slice(-2);
        }
        else {
            return value.slice(-1);
        }
    }
    else {
        return "1";
    }
};
export const setWeekday = (value, weekday) => {
    if (value.includes("#")) {
        return weekday.substring(0, 3) + value;
    }
    else {
        return value + weekday.slice(-2);
    }
};
export const sanitizeCron = (cron) => {
    let sanitizedCron = "";
    Object.values(cron).forEach((value) => {
        sanitizedCron = sanitizedCron + value + " ";
    });
    return sanitizedCron.trimEnd();
};
//# sourceMappingURL=utils.js.map